import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as CreateEmailChallengeGenericError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { InvalidParameterError as CreateEmailChallengeInvalidParameterError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { UnauthorizedError as CreateEmailChallengeUnauthorizedError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { NotificationAlreadySentError as CreateEmailChallengeNotificationAlreadySentError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { ForbiddenError as CreateEmailChallengeForbiddenError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { ChallengeAlreadyExistError as CreateEmailChallengeChallengeAlreadyExistError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { InternalServerError as CreateEmailChallengeInternalServerError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { BadGatewayError as CreateEmailChallengeBadGatewayError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { GatewayTimeoutError as CreateEmailChallengeGatewayTimeoutError } from "./types/CreateEmailChallenge/CreateEmailChallengeError";
import { GenericError as GetEmailChallengeGenericError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { InvalidParameterError as GetEmailChallengeInvalidParameterError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { UnauthorizedError as GetEmailChallengeUnauthorizedError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { ForbiddenError as GetEmailChallengeForbiddenError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { NotFoundError as GetEmailChallengeNotFoundError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { InternalServerError as GetEmailChallengeInternalServerError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { BadGatewayError as GetEmailChallengeBadGatewayError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { GatewayTimeoutError as GetEmailChallengeGatewayTimeoutError } from "./types/GetEmailChallenge/GetEmailChallengeError";
import { GenericError as UpdateEmailChallengeGenericError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { InvalidParameterError as UpdateEmailChallengeInvalidParameterError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { UnauthorizedError as UpdateEmailChallengeUnauthorizedError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { InvalidTokenError as UpdateEmailChallengeInvalidTokenError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { ForbiddenError as UpdateEmailChallengeForbiddenError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { InternalServerError as UpdateEmailChallengeInternalServerError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { BadGatewayError as UpdateEmailChallengeBadGatewayError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
import { GatewayTimeoutError as UpdateEmailChallengeGatewayTimeoutError } from "./types/UpdateEmailChallenge/UpdateEmailChallengeError";
export const errors = {
    CreateEmailChallenge: {
        InvalidParameterError: CreateEmailChallengeInvalidParameterError,
        UnauthorizedError: CreateEmailChallengeUnauthorizedError,
        NotificationAlreadySentError: CreateEmailChallengeNotificationAlreadySentError,
        ForbiddenError: CreateEmailChallengeForbiddenError,
        ChallengeAlreadyExistError: CreateEmailChallengeChallengeAlreadyExistError,
        InternalServerError: CreateEmailChallengeInternalServerError,
        BadGatewayError: CreateEmailChallengeBadGatewayError,
        GatewayTimeoutError: CreateEmailChallengeGatewayTimeoutError,
        GenericError: CreateEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetEmailChallenge: {
        InvalidParameterError: GetEmailChallengeInvalidParameterError,
        UnauthorizedError: GetEmailChallengeUnauthorizedError,
        ForbiddenError: GetEmailChallengeForbiddenError,
        NotFoundError: GetEmailChallengeNotFoundError,
        InternalServerError: GetEmailChallengeInternalServerError,
        BadGatewayError: GetEmailChallengeBadGatewayError,
        GatewayTimeoutError: GetEmailChallengeGatewayTimeoutError,
        GenericError: GetEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateEmailChallenge: {
        InvalidParameterError: UpdateEmailChallengeInvalidParameterError,
        UnauthorizedError: UpdateEmailChallengeUnauthorizedError,
        InvalidTokenError: UpdateEmailChallengeInvalidTokenError,
        ForbiddenError: UpdateEmailChallengeForbiddenError,
        InternalServerError: UpdateEmailChallengeInternalServerError,
        BadGatewayError: UpdateEmailChallengeBadGatewayError,
        GatewayTimeoutError: UpdateEmailChallengeGatewayTimeoutError,
        GenericError: UpdateEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateEmailChallengeError: {
        InvalidParameterError: CreateEmailChallengeInvalidParameterError,
        UnauthorizedError: CreateEmailChallengeUnauthorizedError,
        NotificationAlreadySentError: CreateEmailChallengeNotificationAlreadySentError,
        ForbiddenError: CreateEmailChallengeForbiddenError,
        ChallengeAlreadyExistError: CreateEmailChallengeChallengeAlreadyExistError,
        InternalServerError: CreateEmailChallengeInternalServerError,
        BadGatewayError: CreateEmailChallengeBadGatewayError,
        GatewayTimeoutError: CreateEmailChallengeGatewayTimeoutError,
        GenericError: CreateEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetEmailChallengeError: {
        InvalidParameterError: GetEmailChallengeInvalidParameterError,
        UnauthorizedError: GetEmailChallengeUnauthorizedError,
        ForbiddenError: GetEmailChallengeForbiddenError,
        NotFoundError: GetEmailChallengeNotFoundError,
        InternalServerError: GetEmailChallengeInternalServerError,
        BadGatewayError: GetEmailChallengeBadGatewayError,
        GatewayTimeoutError: GetEmailChallengeGatewayTimeoutError,
        GenericError: GetEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateEmailChallengeError: {
        InvalidParameterError: UpdateEmailChallengeInvalidParameterError,
        UnauthorizedError: UpdateEmailChallengeUnauthorizedError,
        InvalidTokenError: UpdateEmailChallengeInvalidTokenError,
        ForbiddenError: UpdateEmailChallengeForbiddenError,
        InternalServerError: UpdateEmailChallengeInternalServerError,
        BadGatewayError: UpdateEmailChallengeBadGatewayError,
        GatewayTimeoutError: UpdateEmailChallengeGatewayTimeoutError,
        GenericError: UpdateEmailChallengeGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
